import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { useNonprofitAffiliationLogic } from './hooks/useNonprofitAffiliationLogic';
import { NonprofitAffiliationForm } from './NonprofitAffiliationForm';

export const EddNonprofitAffiliation = () => {
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useNonprofitAffiliationLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        text={t('organic.nonprofitAffiliation.title')}
        textCustomStyle='mt-[16px] text-text-main-primary text-[16px] whitespace-pre-line'
        headingContainerCustomStyle='!mb-[16px]'>
        <NonprofitAffiliationForm />
      </StepPageWrapper>
    </FormProvider>
  );
};
